import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Box,
  Typography,
  Stack,
  LinearProgress
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { FRONTEND_SKILLS, BACKEND_SKILLS, OTHER_SKILLS, Skill } from "../constants/skills";

const skills = [...FRONTEND_SKILLS, ...BACKEND_SKILLS, ...OTHER_SKILLS];
const maxYears = Math.max(...skills.map(skill => skill.years));

interface SkillsDialogProps {
  open: boolean
  handleClose: () => void;
}

const SkillsDialog = (props: SkillsDialogProps) => {
  const { open, handleClose } = props;


  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ fontSize: "18px", py: "10px"}}>Skills Breakdown</DialogTitle>
       <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
      <DialogContent sx={{ pt: 0}}>
      <Typography variant='h5' py={1}>
          Frontend
      </Typography>
      <Stack spacing={2} pb={1}> 
        {FRONTEND_SKILLS.map((skill) => (
          <SkillLinearProgress key={skill.name} {...skill as Skill} />
        ))}
      </Stack>
           <Typography variant='h5' py={1}>
          Backend
      </Typography>
      <Stack spacing={2} pb={1}> 
        {BACKEND_SKILLS.map((skill) => (
          <SkillLinearProgress key={skill.name} {...skill as Skill} />
        ))}
      </Stack>
           <Typography variant='h5' py={1}>
           Cloud & Other Developer Tools
      </Typography>
      <Stack spacing={2}> 
        {OTHER_SKILLS.map((skill) => (
          <SkillLinearProgress key={skill.name} {...skill as Skill} />
        ))}
      </Stack>
      
      </DialogContent>
    </Dialog>
  )
}

const SkillLinearProgress = (skill: Skill) => {
  return (
        <Box key={skill.name} sx={{ px: 1 }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 0.5,
              }}
            >
              <Typography variant="caption" fontWeight={500}>
                {skill.name}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {skill.years} yr{skill.years > 1 ? "s" : ""}
              </Typography>
            </Box>

            <LinearProgress
              variant="determinate"
              value={(skill.years / maxYears) * 100}
              sx={{
                height: 8,
                borderRadius: 5,
                "& .MuiLinearProgress-bar": {
                  borderRadius: 5,
                  backgroundColor: "#1976d2"
                },
              }}
            />
          </Box>
  )
}

export default SkillsDialog;